module.exports = __webpack_public_path__ + "static/media/b2.3b39c006.png";